module.exports = __webpack_public_path__ + "static/media/main.6d02800c.png";